import { useGlobalState } from "../globalState/GlobalStateProvider";
import React, { useMemo } from "react";

type Props = {
  children: React.ReactNode;
};

const Container = ({children} : Props) => {
    const stateGlobal = useGlobalState();
    const marginTop = useMemo(() => '56px', []);
    const marginLeft = useMemo(() => {
      return !!stateGlobal.state?.sidebarOpen
        ? '292px'
        : '92px';
    }, [stateGlobal]);
    
    return (
        <div style={{marginTop:marginTop, marginLeft:marginLeft}}>
            <div style={{width:'98%'}}>
                <>
                  {children}
                </>
            </div>
        </div>
    );
  };
  
  export default Container;
